import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { AutoStartControl } from "appworks/ui/controls/standard/button/auto-start-control";
import { ControlFactory } from "../control-factory";

export class AutoStartControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("autoplay_radio_1") != null;
    }

    public build(layer: Layers): AbstractControl[] {
        return [ 
            new AutoStartControl(layer.getFlexiButton("autoplay_radio_1")),
            new AutoStartControl(layer.getFlexiButton("autoplay_radio_2")),
            new AutoStartControl(layer.getFlexiButton("autoplay_radio_3")),
            new AutoStartControl(layer.getFlexiButton("autoplay_radio_4")),
        ];
    }
}